module.exports = __webpack_public_path__ + "img/xyimg.4fc0d735.png";